import { render } from "./ContentSejarah.vue?vue&type=template&id=d8fbf81a&scoped=true"
import script from "./ContentSejarah.vue?vue&type=script&lang=js"
export * from "./ContentSejarah.vue?vue&type=script&lang=js"

import "./ContentSejarah.vue?vue&type=style&index=0&id=d8fbf81a&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fbf81a"]])

export default __exports__